import React from "react";
import { useTranslate } from "@refinedev/core";
import { Modal, Card, Space, Typography, Button } from "antd";
import { DownloadOutlined, SendOutlined } from "@ant-design/icons";

interface AssemblyFiles {
    ecuxFileId: string;
    modifiedBinFileId: string;
    finalOutFileName: string;
}

interface AssemblyFilesModalProps {
    open: boolean;
    onCancel: () => void;
    assemblyFiles: AssemblyFiles | null;
    assemblyFilesLoading: { [key: string]: boolean };
    creatingAttachment: boolean;
    onDownloadFile: (fileId: string, fileName: string) => void;
    onCreateAttachment: () => void;
}

export const AssemblyFilesModal: React.FC<AssemblyFilesModalProps> = ({
    open,
    onCancel,
    assemblyFiles,
    assemblyFilesLoading,
    creatingAttachment,
    onDownloadFile,
    onCreateAttachment,
}) => {
    const _t = useTranslate();

    const ecuxFileName = assemblyFiles?.finalOutFileName.split(".")[0] + ".ecux";

    return (
        <Modal
            title={_t("orders.automationTasks.assemblyFiles.title")}
            open={open}
            onCancel={onCancel}
            width={600}
            footer={null}
        >
            {assemblyFiles && (
                <Space direction="vertical" size="large" className="w-full">
                    <Card size="small">
                        <Space direction="vertical" size="small" className="w-full">
                            <Typography.Text strong>
                                {_t("orders.automationTasks.assemblyFiles.ecuxFile")}
                            </Typography.Text>
                            <Button
                                type="primary"
                                icon={<DownloadOutlined />}
                                onClick={() => onDownloadFile(assemblyFiles.ecuxFileId, ecuxFileName)}
                                loading={assemblyFilesLoading[assemblyFiles.ecuxFileId]}
                                disabled={assemblyFilesLoading[assemblyFiles.ecuxFileId]}
                            >
                                {_t("orders.automationTasks.assemblyFiles.downloadEcuxFile")}
                            </Button>
                        </Space>
                    </Card>

                    <Card size="small">
                        <Space direction="vertical" size="small" className="w-full">
                            <Typography.Text strong>
                                {_t("orders.automationTasks.assemblyFiles.modifiedBinFile")}
                            </Typography.Text>
                            <Space>
                                <Button
                                    type="primary"
                                    icon={<DownloadOutlined />}
                                    onClick={() =>
                                        onDownloadFile(
                                            assemblyFiles.modifiedBinFileId,
                                            assemblyFiles.finalOutFileName
                                        )
                                    }
                                    loading={assemblyFilesLoading[assemblyFiles.modifiedBinFileId]}
                                    disabled={
                                        assemblyFilesLoading[assemblyFiles.modifiedBinFileId] ||
                                        creatingAttachment
                                    }
                                >
                                    {_t("orders.automationTasks.assemblyFiles.downloadModifiedBinFile")}
                                </Button>
                                <Button
                                    type="primary"
                                    icon={<SendOutlined />}
                                    onClick={onCreateAttachment}
                                    loading={creatingAttachment}
                                    disabled={
                                        creatingAttachment ||
                                        assemblyFilesLoading[assemblyFiles.modifiedBinFileId]
                                    }
                                >
                                    {_t("orders.automationTasks.assemblyFiles.createAttachment")}
                                </Button>
                            </Space>
                        </Space>
                    </Card>
                </Space>
            )}
        </Modal>
    );
};
